/**
 * Six topic question router tiles for the homepage.
 * Each tile resolves to a lesson by title-keyword match (lessons table titles).
 */
export interface TopicTile {
  id: string;
  dot: "red" | "yellow" | "black";
  statement: string;
  lessonTitleMatch: string; // case-insensitive substring of lesson title
  lessonLabel: string; // display label
}

export const TOPIC_TILES: TopicTile[] = [
  {
    id: "atrama",
    dot: "red",
    statement: "Kitiems esi atrama, bet nesijauti vertinama.",
    lessonTitleMatch: "atrama",
    lessonLabel: "Nustok būti visų atrama",
  },
  {
    id: "pasakyti",
    dot: "yellow",
    statement: "Jautiesi ne viską pasakanti garsiai ir tai virsta į pyktį",
    lessonTitleMatch: "pasakyti",
    lessonLabel: "Pasakyti ir nesusipykti",
  },
  {
    id: "save",
    dot: "black",
    statement: "Moki būti tik su kitais, bet pačiai su savimi nejauku.",
    lessonTitleMatch: "grįžk",
    lessonLabel: "Grįžk į save",
  },
  {
    id: "charizma",
    dot: "red",
    statement: "Jautiesi nematoma ir svajoji apie lengvumą bendraujant.",
    lessonTitleMatch: "charizma",
    lessonLabel: "Tapk charizmatiška",
  },
  {
    id: "kale",
    dot: "yellow",
    statement: "Tau sunku atsiprašyti. Sunku ir padėkoti.",
    lessonTitleMatch: "nedėkinga",
    lessonLabel: "Tu nedėkinga kalė",
  },
  {
    id: "atsparumas",
    dot: "black",
    statement: "Jautiesi kaip atvira žaizda - gėdijiesi savo jautrumo.",
    lessonTitleMatch: "atsparum",
    lessonLabel: "Sustiprink emocinį atsparumą",
  },
];
